import { Group } from '@mantine/core';
import type { DataAccessRequestStatus } from '@repo/api-codegen';
import { Icon, Text } from '@repo/foundations';
import { StatusColorMap } from './statusColorMap';

export function DataAccessRequestStatusBadge({
	status,
}: {
	status: DataAccessRequestStatus;
}) {
	return (
		<Group spacing="2xs">
			<Icon
				name={StatusColorMap[status].iconName}
				color={StatusColorMap[status].iconColor}
				fillColor={StatusColorMap[status].iconFillColor}
			/>
			<Text size="sm">{StatusColorMap[status].label}</Text>
		</Group>
	);
}
